"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _Select = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Select");

var _Select2 = _interopRequireDefault(_Select);

var _Columns = require("@quixeltools/quixel-ui-library/dist/components/common/website/Columns");

var _Columns2 = _interopRequireDefault(_Columns);

var _Hr = require("@quixeltools/quixel-ui-library/dist/components/common/website/Hr");

var _Hr2 = _interopRequireDefault(_Hr);

var _ProductRelease = require("./ProductRelease");

var _ProductRelease2 = _interopRequireDefault(_ProductRelease);

var _polyfluid = require("@quixeltools/quixel-ui-library/dist/utils/polyfluid");

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var container = (0, _glamor.css)({
  width: "100%",

  position: "relative"
});

var title = (0, _glamor.css)({
  display: "block",

  color: _css.colors.white,
  lineHeight: 1.3,
  fontWeight: 300,

  marginTop: (0, _css.unitRem)(0),
  marginBottom: (0, _css.unitRem)(0)
}, (0, _polyfluid.polyfluid)({
  fontSize: {
    small: 1.5,
    medium: 1.685,
    large: [1.685, 2.25]
  }
}));

var hr = (0, _glamor.css)((0, _polyfluid.polyfluid)({
  marginTop: {
    small: 2,
    medium: 2.15,
    large: [2.15, 2.875]
  },
  marginBottom: {
    small: 2,
    medium: 2.15,
    large: [2.15, 2.875]
  }
}));

var ProductReleases = function ProductReleases(_ref) {
  var products = _ref.products,
      filter = _ref.filter,
      setFilter = _ref.setFilter;
  return _react2.default.createElement(
    "div",
    { className: container },
    _react2.default.createElement(
      _Columns2.default,
      { n: 2, className: (0, _glamor.css)({ overflow: "visible" }) },
      _react2.default.createElement(
        "h1",
        { className: title },
        "All Versions"
      ),
      _react2.default.createElement(
        "div",
        { className: (0, _glamor.css)({ textAlign: "right" }) },
        _react2.default.createElement(_Select2.default, {
          options: _ramda2.default.map(function (p) {
            return { name: p, value: p };
          }, _ramda2.default.uniq(_ramda2.default.pluck("platform")(products))),
          value: filter,
          onChange: setFilter
        })
      )
    ),
    _react2.default.createElement(_Hr2.default, { className: hr }),
    products.filter(function (p) {
      return p.platform === filter;
    }).map(function (p) {
      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(_ProductRelease2.default, p),
        _react2.default.createElement(_Hr2.default, { className: hr })
      );
    })
  );
};

exports.default = ProductReleases;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/Mixer/Components/ProductReleases.jsx
// module id = 2931
// module chunks = 0